import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import {
  deleteScoringResultUsingPost,
  listScoringResultVoByPageUsingPost,
} from "@/api/scoringResultController";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";

interface Props {
  appId: string;
  doUpdate?: (scoringResult: API.ScoringResultVO) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScoringResultTable',
  props: {
    appId: { default: () => {
    return "";
  } },
    doUpdate: {}
  },
  setup(__props: any, { expose: __expose }) {

//@ts-ignore
const formSearchParams = ref<API.ScoringResultQueryRequest>({});

// 初始化搜索条件（不应该被修改）
const initSearchParams = {
  current: 1,
  pageSize: 10,
};

const searchParams = ref<API.ScoringResultQueryRequest>({
  ...initSearchParams,
});
const dataList = ref<API.ScoringResultVO[]>([]);
const total = ref<number>(0);

const props = __props;

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  const params = {
    appId: props.appId as any,
    ...searchParams.value,
  };
  const res = await listScoringResultVoByPageUsingPost(params);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 执行搜索
 */
const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    ...formSearchParams.value,
  };
};

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 删除
 * @param record
 */
const doDelete = async (record: API.ScoringResult) => {
  if (!record.id) {
    return;
  }

  const res = await deleteScoringResultUsingPost({
    id: record.id,
  });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

// 暴露函数给父组件
__expose({
  loadData,
});

// 表格列配置
const columns = [
  {
    title: "id",
    dataIndex: "id",
  },
  {
    title: "名称",
    dataIndex: "resultName",
  },
  {
    title: "描述",
    dataIndex: "resultDesc",
  },
  {
    title: "图片",
    dataIndex: "resultPicture",
    slotName: "resultPicture",
  },
  {
    title: "结果属性",
    dataIndex: "resultProp",
  },
  {
    title: "评分范围",
    dataIndex: "resultScoreRange",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: formSearchParams.value,
      style: { marginBottom: '20px' },
      layout: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "resultName",
          label: "结果名称"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              "allow-clear": "",
              modelValue: formSearchParams.value.resultName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSearchParams.value.resultName) = $event)),
              placeholder: "请输入结果名称",
              "search-button": "",
              onSearch: doSearch
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "resultDesc",
          label: "结果描述"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              "allow-clear": "",
              modelValue: formSearchParams.value.resultDesc,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSearchParams.value.resultDesc) = $event)),
              placeholder: "请输入结果描述",
              "search-button": "",
              onSearch: doSearch
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      onPageChange: onPageChange
    }, {
      resultPicture: _withCtx(({ record }) => [
        _createVNode(_component_a_image, {
          width: "64",
          src: record.resultPicture
        }, null, 8, ["src"])
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              status: "success",
              onClick: ($event: any) => (__props.doUpdate?.(record))
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("修改", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("删除", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ], 64))
}
}

})